<template>
    <div
        class="section-set-password container section-change-password-desktop t-transform-cap"
    >
        <ButtonCustom
            type="go-back"
            :text="getTranslatedText('change password')"
            :isGoBackHistory="false"
            @onClickButton="$router.back()"
        />

        <FormCommon
            :formItem="formItem"
            :dataForm="dataForm"
            @on-bur-input="onBurInputFormData"
            @update-form-data="updateFormData"
            @onSubmitForm="onSubmitForm"
            @onToggleShowPassword="onToggleShowPassword"
            class="section-change-password-desktop__form" 
        >
            <div class="box-btn" slot="button">
                <div class="register-btn">
                    <ButtonCustom
                        classBtn="register-btn-close"
                        typeBtn="button"
                        type="default"
                        text="cancel"
                        @onClickButton="$router.back()"
                    />
                    <ButtonCustom
                        classBtn="register-btn-continue"
                        typeBtn="submit"
                        type="primary"
                        :isLoading="isLoadingButton"
                        text="done"
                    />
                </div>
            </div>
        </FormCommon>
        <Toast :title="toastData.message" :type="toastData.type" />
    </div>
</template>
<script>

import { isStrEmpty } from "@/components/common/utils";

import AuthService from "@/services/auth.service";
import FormCommon from "@/components/common/form";
import ButtonCustom from "@/components/common/button";
import Toast from "@/components/common/toast/Toast.vue";

import languageMixin from "@/mixins/language/language-mixin";

const LIMIT_PASSWORD = process.env.VUE_APP_LIMIT_PASSWORD;

export default {
    mixins: [languageMixin],
    components: {
        FormCommon,
        ButtonCustom,
        Toast,
    },
    data() {
        return {
            toastData: {
                message: "",
                type: "success",
            },
            isLoadingButton: false,
            timerCount: 60,
            isDisableResend: true,
            dataForm: {
                current_password: "",
                new_password: "",
                confirm_password: "",
                isCheckPassWord: [],
            },
            formItem: [
                {
                    type: "input",
                    typeInput: "password",
                    typeShow: 'password',
                    hideIconRq: true,
                    placeholder: "",
                    name: "current_password",
                    required: true,
                    label: "old password",
                    for: "input-password",
                    id: "input-password",
                    state: null,
                    textInvalid: "please enter the correct password",
                    textValid: "",
                },
                {
                    type: "input",
                    typeInput: "password",
                    typeShow: 'password',
                    hideIconRq: true,
                    placeholder: "",
                    name: "new_password",
                    required: true,
                    label: "enter password",
                    for: "input-password",
                    id: "input-password",
                    state: null,
                    textInvalid: "please enter the correct password",
                    textValid: "",
                },
                {
                    type: "checkBox",
                    name: "isCheckPassWord",
                    label: "password must contain",
                    id: "check-pass-word",
                    class: "validate-pass-word",
                    plain: true,
                    stacked: true,
                    options: [
                        {
                            text: "at least 1 character",
                            value: "1",
                            disabled: true,
                        },
                        {
                            text: "at least 1 number",
                            value: "2",
                            disabled: true,
                        },
                        {
                            text: "at least 1 special character",
                            value: "3",
                            disabled: true,
                        },
                        {
                            text: "at least 1 capital character",
                            value: "4",
                            disabled: true,
                        },
                        {
                            text: this.getTranslatedText(
                                "at least [limit] characters", {
                                    limit: LIMIT_PASSWORD,
                                }
                            ),
                            value: "5",
                            disabled: true,
                        },
                    ],
                },
                {
                    type: "input",
                    typeInput: "password",
                    typeShow: 'password',
                    hideIconRq: true,
                    placeholder: "",
                    name: "confirm_password",
                    required: true,
                    label: "confirm password",
                    for: "input-confirmPassword",
                    id: "input-confirmPassword",
                    state: null,
                    textInvalid: "passwords are not the same",
                    textValid: "",
                },
            ],
        };
    },
    watch: {
        timerCount: {
            handler(value) {
                if (value > 0) {
                    setTimeout(() => {
                        this.timerCount--;
                    }, 1000);
                }
                if (value === 0) {
                    this.isDisableResend = false;
                }
            },
            immediate: true,
        },
    },
    methods: {
        showToast(message, type) {
            this.toastData.message = message;
            this.toastData.type = type;
            this.$bvToast.show("my-toast");
        },
        updateFormData(item) {
            let { value, name } = item;
            if (name === "new_password") {
                let isContainsLowercase = /^(?=.*[a-z]).*$/;
                let isContainsNumber = /^(?=.*[0-9]).*$/;
                let isContainsSymbol =
                    /^(?=.*[~`!@#$%^&*()--+={}[\]|\\:;"'<>,.?/_₹]).*$/;
                let isContainsUppercase = /^(?=.*[A-Z]).*$/;

                // check at least 1 character
                if (
                    isContainsLowercase.test(value) &&
                    !this.dataForm.isCheckPassWord.includes("1")
                ) {
                    this.dataForm.isCheckPassWord.push("1");
                }

                if (
                    !isContainsLowercase.test(value) &&
                    this.dataForm.isCheckPassWord.includes("1")
                ) {
                    let indexCharacter =
                        this.dataForm.isCheckPassWord.findIndex(
                            (x) => x === "1"
                        );
                    this.dataForm.isCheckPassWord.splice(indexCharacter, 1);
                }
                // check at least 1 number
                if (
                    isContainsNumber.test(value) &&
                    !this.dataForm.isCheckPassWord.includes("2")
                ) {
                    this.dataForm.isCheckPassWord.push("2");
                }
                if (
                    !isContainsNumber.test(value) &&
                    this.dataForm.isCheckPassWord.includes("2")
                ) {
                    let indexNumber = this.dataForm.isCheckPassWord.findIndex(
                        (x) => x === "2"
                    );
                    this.dataForm.isCheckPassWord.splice(indexNumber, 1);
                }
                // check at least 1 Symbol
                if (
                    isContainsSymbol.test(value) &&
                    !this.dataForm.isCheckPassWord.includes("3")
                ) {
                    this.dataForm.isCheckPassWord.push("3");
                }
                if (
                    !isContainsSymbol.test(value) &&
                    this.dataForm.isCheckPassWord.includes("3")
                ) {
                    let indexSpecial = this.dataForm.isCheckPassWord.findIndex(
                        (x) => x === "3"
                    );
                    this.dataForm.isCheckPassWord.splice(indexSpecial, 1);
                }
                // check at least 1 capital
                if (
                    isContainsUppercase.test(value) &&
                    !this.dataForm.isCheckPassWord.includes("4")
                ) {
                    this.dataForm.isCheckPassWord.push("4");
                }
                if (
                    !isContainsUppercase.test(value) &&
                    this.dataForm.isCheckPassWord.includes("4")
                ) {
                    let indexCapital = this.dataForm.isCheckPassWord.findIndex(
                        (x) => x === "4"
                    );
                    this.dataForm.isCheckPassWord.splice(indexCapital, 1);
                }

                if (
                    value.length >= LIMIT_PASSWORD &&
                    !this.dataForm.isCheckPassWord.includes("5")
                ) {
                    this.dataForm.isCheckPassWord.push("5");
                }
                if (
                    value.length < LIMIT_PASSWORD  &&
                    this.dataForm.isCheckPassWord.includes("5")
                ) {
                    let indexLimitCharacter = this.dataForm.isCheckPassWord.findIndex(
                        (x) => x === "5"
                    );
                    this.dataForm.isCheckPassWord.splice(indexLimitCharacter, 1);
                }

                if (!isStrEmpty(this.dataForm.confirm_password)) {
                    this.formItem[3].state = null;
                    this.dataForm.confirm_password = "";
                }

                if (
                    this.dataForm.isCheckPassWord.length === 5 &&
                    this.formItem[1].state !== null
                ) {
                    this.formItem[1].state = true;
                }
            }
            this.dataForm[name] = value;
        },

        onBurInputFormData(event) {
            let { value, name } = event.target;
            if (value.length > 3) {
                let item = {
                    value,
                    name,
                };
                this.updateFormData(item);
            }
            if (
                name === "confirm_password" &&
                value === this.dataForm.new_password &&
                !this.formItem[3].state
            ) {
                this.formItem[3].state = true;
            }

            if (
                name === "confirm_password" &&
                value !== this.dataForm.new_password &&
                this.formItem[3].state !== null
            ) {
                this.formItem[3].state = false;
            }
        },

        onSubmitForm() {
            this.isLoadingButton = true;
            if (this.dataForm.isCheckPassWord.length < 5) {
                this.formItem[1].state = false;
                this.isLoadingButton = false;
                return false;
            }

            if (this.dataForm.new_password !== this.dataForm.confirm_password) {
                this.formItem[3].state = false;
                this.isLoadingButton = false;
                return false;
            }
            AuthService.changePassWord(
                this.dataForm.current_password,
                this.dataForm.new_password,
                this.dataForm.confirm_password
            ).then((res) => {
                if (res.status === 200) {
                    this.showToast(
                        this.getTranslatedText(res.message),
                        "success"
                    );
                    this.dataForm = {
                        current_password: "",
                        new_password: "",
                        confirm_password: "",
                        isCheckPassWord: [],
                    };
                    this.formItem[1].state = null;
                    this.formItem[3].state = null;
                } else {
                    this.showToast(
                        this.getTranslatedText(res.message),
                        "error"
                    );
                }
                this.isLoadingButton = false;
            });
        },

        onToggleShowPassword(name) {
            let index = this.formItem.findIndex(x => x.name === name)
            if(index !== -1 ) {
                this.formItem[index].typeShow = this.formItem[index].typeShow === 'password' ? 'text' : 'password'
            }
        }
    },
};
</script>
<style
    scoped
    lang="scss"
    src="@/assets/scss/mobile/authenticate/_register.scss"
/>
